// Slice 41 — boolean toggle. Keyboard-activatable (Space/Enter).

export interface HqToggleProps {
  on: boolean;
  onChange: (v: boolean) => void;
  size?: "sm" | "md" | "lg";
  ariaLabel?: string;
  disabled?: boolean;
}

const SIZES = {
  sm: { w: 26, h: 14, k: 10 },
  md: { w: 32, h: 18, k: 14 },
  lg: { w: 38, h: 22, k: 18 },
} as const;

export function HqToggle({ on, onChange, size = "md", ariaLabel, disabled }: HqToggleProps) {
  const s = SIZES[size];
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel ?? "Toggle"}
      disabled={disabled}
      onClick={() => !disabled && onChange(!on)}
      style={{
        position: "relative",
        width: s.w,
        height: s.h,
        display: "inline-block",
        cursor: disabled ? "not-allowed" : "pointer",
        background: "transparent",
        border: "none",
        padding: 0,
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <span
        style={{
          position: "absolute",
          inset: 0,
          borderRadius: 99,
          background: on ? "var(--hq-accent)" : "var(--hq-border-strong)",
          transition: "background .15s",
        }}
      />
      <span
        style={{
          position: "absolute",
          top: 2,
          left: on ? s.w - s.k - 2 : 2,
          width: s.k,
          height: s.k,
          borderRadius: 99,
          background: on ? "#04101a" : "var(--hq-text-dim)",
          transition: "left .18s",
        }}
      />
    </button>
  );
}
